import { AxiosError } from 'axios';

/**
 * A 409 means a version conflict. The response interceptor already handles it by
 * showing the version-conflict dialog, so callers must not also surface a generic
 * error toast — guard catch-block toasts with this to avoid the double notification.
 */
export const isVersionConflictError = (error: unknown): boolean =>
  validateIsAxiosError(error as Error) && (error as AxiosError)?.response?.status === 409;

export const validateIsAxiosError = (error: Error) => {
  if (error.name === 'AxiosError') {
    return true;
  }

  if (
    typeof error === 'object' &&
    !Array.isArray(error) &&
    error !== null &&
    'isAxiosError' in error
  ) {
    return true;
  }

  return false;
};
